export default "__VITE_ASSET__Bbbu51T3__"